import {camelCase} from "lodash";

export default {
    name: 'course-dashboard-graduate-work',
    props: {
        currentItem: {}
    },
    methods: {
        setStatusModuleItem(item) {
            return item.graduateWork.data.userGraduateWork.data.hasOwnProperty('id') ? item.graduateWork.data.userGraduateWork.data.status : 'new'
        },
        getCamelCase(text) {
            return camelCase(text);
        },
        getStatus(item) {
            let cnf = null;
            cnf = item.graduateWork.data.userGraduateWork.data
            return cnf.status
        },
    }
}
